module.exports = __webpack_public_path__ + "static/img/logo_3 - 副本.f22701d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_3 - 副本.png
// module id = X+G+
// module chunks = 0